export default "__VITE_ASSET__DzfSROUU__"